import type { EmployeeGroup, LeavePolicy, LeavePolicyStatus } from '../types/hrmsLeavePolicies.types'

export const GROUP_HEADCOUNTS: Record<EmployeeGroup, number> = {
  'Teaching Staff': 290,
  'Non-Teaching Staff': 196,
}

export const MOCK_LEAVE_POLICIES: LeavePolicy[] = [
  {
    id: 'lp-1',
    name: 'Teaching Staff – Casual Leave',
    leaveType: 'Casual Leave',
    employeeGroup: 'Teaching Staff',
    entitlementDays: 12,
    carryForwardDays: 5,
    status: 'Active',
  },
  {
    id: 'lp-2',
    name: 'Teaching Staff – Sick Leave',
    leaveType: 'Sick Leave',
    employeeGroup: 'Teaching Staff',
    entitlementDays: 10,
    carryForwardDays: 0,
    status: 'Active',
  },
  {
    id: 'lp-3',
    name: 'Teaching Staff – Earned Leave',
    leaveType: 'Earned Leave',
    employeeGroup: 'Teaching Staff',
    entitlementDays: 15,
    carryForwardDays: 10,
    status: 'Active',
  },
  {
    id: 'lp-4',
    name: 'Non-Teaching Staff – Casual Leave',
    leaveType: 'Casual Leave',
    employeeGroup: 'Non-Teaching Staff',
    entitlementDays: 12,
    carryForwardDays: 5,
    status: 'Active',
  },
  {
    id: 'lp-5',
    name: 'Non-Teaching Staff – Sick Leave',
    leaveType: 'Sick Leave',
    employeeGroup: 'Non-Teaching Staff',
    entitlementDays: 10,
    carryForwardDays: 0,
    status: 'Active',
  },
  {
    id: 'lp-6',
    name: 'Non-Teaching Staff – Earned Leave',
    leaveType: 'Earned Leave',
    employeeGroup: 'Non-Teaching Staff',
    entitlementDays: 15,
    carryForwardDays: 10,
    status: 'Active',
  },
]

export const EMPLOYEE_GROUP_FILTER_OPTIONS = [
  { label: 'All', value: 'All' },
]

export const LEAVE_POLICY_STATUS_FILTER_OPTIONS = [
  { label: 'All Status', value: 'All Status' },
  { label: 'Active', value: 'Active' },
  { label: 'Inactive', value: 'Inactive' },
]

export const LEAVE_POLICY_STATUS_STYLES: Record<
  string,
  { bg: string; text: string; border: string; dot: string }
> = {
  Active: {
    bg: 'bg-emerald-50',
    text: 'text-emerald-700',
    border: 'border-emerald-200',
    dot: 'bg-emerald-500',
  },
  ACTIVE: {
    bg: 'bg-emerald-50',
    text: 'text-emerald-700',
    border: 'border-emerald-200',
    dot: 'bg-emerald-500',
  },
  Inactive: {
    bg: 'bg-slate-100',
    text: 'text-slate-600',
    border: 'border-slate-200',
    dot: 'bg-slate-400',
  },
  INACTIVE: {
    bg: 'bg-slate-100',
    text: 'text-slate-600',
    border: 'border-slate-200',
    dot: 'bg-slate-400',
  },
}
